import { render, staticRenderFns } from "./ApplicationPersonalNumber.vue?vue&type=template&id=5509b882&scoped=true&"
import script from "./ApplicationPersonalNumber.vue?vue&type=script&lang=js&"
export * from "./ApplicationPersonalNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509b882",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VForm,VTextField})
